// extracted by mini-css-extract-plugin
export var brand = "_1m-9";
export var button = "_1m-0";
export var chevron = "_1m-v";
export var chevronButton = "_1m-w";
export var content = "_1m-n";
export var danger = "_1m-g";
export var dangerOutlined = "_1m-h";
export var dark = "_1m-l";
export var darkTheme = "_1m-c";
export var extraSmall = "_1m-4";
export var fullWidth = "_1m-8";
export var ghost = "_1m-d";
export var gray = "_1m-t";
export var icon = "_1m-p";
export var iconButton = "_1m-s";
export var iconButtonBorder = "_1m-x";
export var iconButtonBorderDark = "_1m-y";
export var iconButtonBorderLight = "_1m-z";
export var iconLeft = "_1m-q";
export var iconRight = "_1m-r";
export var large = "_1m-1";
export var light = "_1m-m";
export var medium = "_1m-2";
export var micro = "_1m-5";
export var nano = "_1m-7";
export var outlined = "_1m-k";
export var pending = "_1m-a";
export var primary = "_1m-i";
export var shadow = "_1m-o";
export var small = "_1m-3";
export var solidLight = "_1m-e";
export var solidLightBrand = "_1m-f";
export var spinner = "_1m-u";
export var transparent = "_1m-j";
export var warning = "_1m-b";
export var wideNano = "_1m-6";